import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ServiceProviderGuideModal = ({ open, setOpenModal }) => {
    return (
        <Modal open={open} onClose={() => setOpenModal(false)}>
            <Box sx={{
                p: 4,
                bgcolor: "white",
                borderRadius: 2,
                width: "90%",
                maxWidth: "600px",
                margin: "auto",
                mt: 5
            }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>SERVICE PROVIDER REQUIREMENTS TO LIST ON GET SORTED</Typography>
                    <IconButton onClick={() => setOpenModal(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>1. Criminal Check</Typography>
                <Typography variant="body2">
                    All service providers must complete a criminal check at any POSTNET or Jetline store, and upload the report when signing up to Get Sorted.
                </Typography>

                <Typography variant="body2" sx={{ mt: 2, fontWeight: "bold" }}>2. ID Verification with Photo</Typography>
                <Typography variant="body2">
                    All service providers must upload a scanned version of their original South African ID Card (front & back).
                    With this, the provider must also submit a selfie (shoulders up), with a plain white background (a white wall). Photo must be recent.
                </Typography>

                <Typography variant="body2" sx={{ mt: 2, fontWeight: "bold" }}>3. Qualification Verification</Typography>
                <Typography variant="body2">
                    All service providers must upload their scanned original certification/license verifying their qualification in the service they wish to provide on Get Sorted.
                    For services that do not have formal qualifications (e.g. dog walking, dog sitting, cleaning, etc.), providers must upload a written document stating the specific service they wish to offer, including the number of years of experience and contact details of individuals/companies they have previously provided this service to.
                </Typography>

                <Typography variant="body2" sx={{ mt: 2, fontWeight: "bold" }}>4. Proof of Address</Typography>
                <Typography variant="body2">
                    All service providers must upload a proof of address.
                    Accepted documents include Bank Statement, Utility Bill, or Lease Agreement.
                </Typography>

                <Typography variant="body2" sx={{ mt: 2, fontWeight: "bold" }}>5. Insurance</Typography>
                <Typography variant="body2">
                    All service providers must have their own insurance coverage.
                    Upload proof of insurance.
                </Typography>
            </Box>
        </Modal>
    );
};

export default ServiceProviderGuideModal;
